
export class TaleoftheTape {
  constructor({
    animate,
    preview,
    update,
    animateOff,
    getVizPage,
    updateVizPage,
    vizSharedMemory,
  }) {
    this.onAir = false;
    this.sendAnimate = animate;
    this.sendAnimateOff = animateOff;
    this.sendPreview = preview;
    this.sendUpdate = update;
    this.getVizPage = getVizPage;
    this.updateVizPage = updateVizPage;
    this.vizSharedMemory = vizSharedMemory;
    this.name = "Tale of the Tape";
    this.scene = "Tale of the Tape";
    this.data = [];
    this.page = 9011;
  }

  async preview({ options }) {
    this.onAir = false;

    await this.updateData({ options, show: 1 });
    // await this.updateData({ options, show: 2 });
    // await this.updateData({ options, show: 3 });
    // await this.updateData({ options, show: 4 });
    await this.sendPreview("page:read " + this.page);
  }
  async animate({ options }) {
    this.onAir = true;
    this.sendAnimate({ page: this.page });
  }
  animateOff({ options }) {
    this.onAir = false;
    this.sendAnimateOff({ page: this.page });
  }

  async updateData({ options, show }) {
    let xml = await this.getVizPage({ page: this.page, show }).catch((err) => {
      console.log(err);
    });
    if (xml) {
      xml.payload.field.find((item) => {
        return item.attr.name === "1100";
      }).value = (options?.game?.home_fighter?.first_name.toUpperCase()  || "");

      xml.payload.field.find((item) => {
        return item.attr.name === "1101";
      }).value = (options?.game?.home_fighter?.last_name.toUpperCase()  || "");


      xml.payload.field.find((item) => {
        return item.attr.name === "1200";
      }).value = (options?.game?.away_fighter?.first_name.toUpperCase()  || "");

      xml.payload.field.find((item) => {
        return item.attr.name === "1201";
      }).value = (options?.game?.away_fighter?.last_name.toUpperCase()  || "");

      xml.payload.field.find((item) => {
        return item.attr.name === "1111";
      }).value = (options?.game?.home_fighter?.weight.toUpperCase() || "");

      xml.payload.field.find((item) => {
        return item.attr.name === "1211";
      }).value = (options?.game?.away_fighter?.weight.toUpperCase() || "");

      xml.payload.field.find((item) => {
        return item.attr.name === "1110";
      }).value = (options?.game?.home_fighter?.age || "");

      xml.payload.field.find((item) => {
        return item.attr.name === "1210";
      }).value = (options?.game?.away_fighter?.age || "");

      xml.payload.field.find((item) => {
        return item.attr.name === "1113";
      }).value = (options?.game?.home_fighter?.height || "");

      xml.payload.field.find((item) => {
        return item.attr.name === "1213";
      }).value = (options?.game?.away_fighter?.height || "");

      xml.payload.field.find((item) => {
        return item.attr.name === "1116";
      }).value = (options?.game?.prediction_data?.engagement?.total?.percentage_a || "");

      xml.payload.field.find((item) => {
        return item.attr.name === "1216";
      }).value = (options?.game?.prediction_data?.engagement?.total?.percentage_b || "");

      xml.payload.field.find((item) => {
        return item.attr.name === "2001";
      }).value = "AGE";

      xml.payload.field.find((item) => {
        return item.attr.name === "2002";
      }).value = "WEIGHT";

      xml.payload.field.find((item) => {
        return item.attr.name === "2003";
      }).value = "STYLE";

      xml.payload.field.find((item) => {
        return item.attr.name === "2004";
      }).value = "HEIGHT";

      xml.payload.field.find((item) => {
        return item.attr.name === "2005";
      }).value = "COUNTRY";

      xml.payload.field.find((item) => {
        return item.attr.name === "8000";
      }).value = options?.fanvoteomo;




      xml.payload.field.find((item) => {
        return item.attr.name === "1112";
      }).value = (options?.game?.home_fighter?.style.toUpperCase() || "");

      xml.payload.field.find((item) => {
        return item.attr.name === "1212";
      }).value = (options?.game?.away_fighter?.style.toUpperCase() || "");

      xml.payload.field.find((item) => {
        return item.attr.name === "1215";
      }).value =
        options?.game?.competition?.flag_path +
        (options.game?.away_fighter?.nationality?.code || "");

      xml.payload.field.find((item) => {
        return item.attr.name === "1207";
      }).value =
        options?.game?.competition?.fighter_full_path +
        (options.game?.away_fighter?.image || "");

              xml.payload.field.find((item) => {
        return item.attr.name === "1115";
      }).value =
        options?.game?.competition?.flag_path +
        (options.game?.home_fighter?.nationality?.code || "");

      xml.payload.field.find((item) => {
        return item.attr.name === "1107";
      }).value =
        options?.game?.competition?.fighter_full_path +
        (options.game?.home_fighter?.image || "");

      
      xml.payload.field.find((item) => {
        return item.attr.name === "1001";
      }).value = options?.game?.title || "";

      

      await this.updateVizPage({
        page: this.page,
        data: xml,
        escape: false,
        show,
      }).catch((err) => {
        console.log(err);
      });
    }
  }

  update({ options }) {}
}
